import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { QuoterStateService } from './features/quoter/services/quoter-state.service';
import { StorageService } from './core/infrastructure/services/storage/storage.service';
import { IdleTimeoutService } from './core/infrastructure/services/idle-timeout/idle-timeout.service';
import { LeadUnloadUpdateService } from './core/infrastructure/services/lead/lead-unload-update.service';
import { CampaignAttributionService } from './core/infrastructure/services/campaign/campaign-attribution.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: `<router-outlet />`,
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly quoterState = inject(QuoterStateService);
  private readonly StorageService = inject(StorageService);
  private readonly idleTimeoutService = inject(IdleTimeoutService);
  private readonly leadUnloadUpdateService = inject(LeadUnloadUpdateService);
  private readonly campaignAttributionService = inject(CampaignAttributionService);
  private readonly onPageHide = () => {
    this.quoterState.saveStateSnapshot();
    this.leadUnloadUpdateService.tryDispatchUpdateOnUnload();
  };

  constructor() {
    const sessionId = crypto.randomUUID();
    this.StorageService.setLocalItem('session_id', sessionId);
  }

  ngOnInit(): void {
    if (typeof window === 'undefined') {
      return;
    }

    window.addEventListener('pagehide', this.onPageHide);
    window.addEventListener('beforeunload', this.onPageHide);
    this.campaignAttributionService.init();
    this.leadUnloadUpdateService.init();
    this.idleTimeoutService.init();
  }

  ngOnDestroy(): void {
    if (typeof window === 'undefined') {
      return;
    }

    window.removeEventListener('pagehide', this.onPageHide);
    window.removeEventListener('beforeunload', this.onPageHide);
    this.campaignAttributionService.stop();
    this.leadUnloadUpdateService.stop();
    this.idleTimeoutService.stop();
  }
}
